import { environment } from '../../environments/environment';

export const API_VERSION = Object({
    'version': environment.apiVersion,
    'base': environment.apiBaseUrl
});
